import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import CacheStorage from "../../../service/storage/CacheStorage";
import StorageKeys from "../../../const/StorageKeys";
import ShowToast from "../../../widget/common/ui/Toast";
import { AutomatedReplyModel } from "../../../model/work_profile/AutomatedReplyModel";

const AutomatedReplyProvider = new (class AutomatedReplyProvider {
  updateAutomatedAPI = async (params: {
    message: string;
    status?: boolean;
  }): Promise<boolean> => {
    ApiUrls.init();

    const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
    const url: string = `${ApiUrls.baseUrl}settings/menu/manage_automated_reply_message`;

    const status: boolean = params.status ?? true;

    const body: any = {
      account_id: accountId,
      flag: status ? "1" : "0",
      message: params.message,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return false;
  };

  getAutomatedAPI = async (): Promise<AutomatedReplyModel | null> => {
    ApiUrls.init();

    const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
    const url: string = `${ApiUrls.baseUrl}settings/menu/automated_reply_message`;

    const body: any = {
      account_id: accountId,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const menuStatusListModel: AutomatedReplyModel = response;

        return menuStatusListModel;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default AutomatedReplyProvider;
